import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TestForm from "../form";
import { jwtDecode } from "jwt-decode";
import DatePicker from "react-datepicker";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { getNames } from "country-list";
import axios from "axios";
import RequiredTestsDropdown from "../requesttest";
import ResuestSample from "../requestsample";
import { MdDelete, MdDeleteOutline } from "react-icons/md";
function SupplyRequest() {
    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_BASE_URL_DEV
            : process.env.REACT_APP_BASE_URL_PROD;
    AOS.init();
    const [showAdditionalContent, setShowAdditionalContent] = useState(false);
    const [userInfo1, setUserInfo1] = useState({});

    const [packageInfo, setPackageInfo] = useState([]);
    const location = useLocation();
    const [showContent, setShowContent] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const categoryId = queryParams.get("id");
    const navigate = useNavigate();
    const tokenn = localStorage.getItem("aqua");
    const [book, setBook] = useState(false);
    const [book2, setBook2] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [popup, setPopup] = useState({
        visible: false,
        message: "",
        isError: false,
    });
    const [popup12, setPopup12] = useState({
        visible: false,
        message: "",
        isError: false,
    });
    const [loggedIn, setLoggedIn] = useState(false);

    const [formData, setFormData] = useState({
        title: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        gender: "",
        address1: "",
        address2: "",
        clinicName: "",
        postalCode: "",
        country: "",
        nhsNumber: "",
        requiredTests: [],
        TubesNumber: "",
        fasting: false,
        clinicComplain: "",
        additionalRemark: "",

        promtotionCode: "",
        dob: null,
        SerumTypes: [],
        Pregnant: false,
        patientname: "",
        patientnumber: "",
        patientemail: "",
        city: "",
        streetname: "",
        // isClickInOwner :''
    });

    //
    const [formData1, setFormData1] = useState({
        clinicName1: "",
        phoneNumber1: "",
        email1: "",
        address11: "",
        materials: [
            {
                materialName: "",
                qty: "",
                unit: "",
                manufacturerName: "",
                batchNumber: "",
                expiryDate: "",
            },
        ],
    });

    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setFormData1((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handlePhoneNumberChange12 = (value) => {
        setFormData1((prevData) => ({
            ...prevData,
            phoneNumber1: value,
        }));
    };

    const addMaterialRow = () => {
        setFormData1((prevData) => ({
            ...prevData,
            materials: [
                ...(prevData.materials || []),
                {
                    materialName: "",
                    qty: "",
                    unit: "",
                    manufacturerName: "",
                    batchNumber: "",
                    expiryDate: "",
                },
            ],
        }));
    };

    const handleMaterialChange = (index, e) => {
        const { name, value } = e.target;
        setFormData1((prevData) => {
            const newMaterials = [...prevData.materials];
            newMaterials[index][name] = value;
            return { ...prevData, materials: newMaterials };
        });
    };

    const removeMaterialRow = (index) => {
        setFormData1((prevData) => ({
            ...prevData,
            materials: prevData.materials.filter((_, i) => i !== index),
        }));
    };

    const handleBooking1 = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${baseUrl}/booking/sampleRequest`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("aqua")}`,
                },
                body: JSON.stringify(formData1),
            });

            const result = await response.json();
            if (result.isSuccess) {
                showPopup12("Sample request submitted successfully!", false);
                setFormData1({
                    clinicName1: "",
                    phoneNumber1: "",
                    email1: "",
                    address11: "",
                    materials: [
                        {
                            materialName: "",
                            qty: "",
                            unit: "",
                            manufacturerName: "",
                            batchNumber: "",
                            expiryDate: "",
                        },
                    ],
                });
            } else {
                showPopup12("Failed to submit sample request.", true);
            }
        } catch (error) {
            console.error("Error submitting sample request:", error);
            showPopup12("An error occurred. Please try again.", true);
        }
    };

    const showPopup12 = (message, isError = false) => {
        setPopup12({
            visible: true,
            message,
            isError,
        });
        setBook2(!book2);
    };

    const closePopup12 = () => {
        setPopup12((prev) => ({
            ...prev,
            visible: false,
        }));
        setBook2(!book2);
    };
    //

    // const userInfo = jwtDecode(tokenn);

    const countries = getNames();
    const modifiedCountries = [...countries, "United Kingdom"];

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(
                    `${baseUrl}/home/category?categoryId=${categoryId}`
                );
                if (!response.ok) {
                    throw new Error("Unable to fetch data");
                }
                const data = await response.json();
                setPackageInfo(data);
            } catch (error) {
                console.error("Error fetching services:", error);
                setPackageInfo([]);
            }
        };

        fetchServices();
    }, [categoryId]);

    const handleLearnMoreClick = () => {
        if (categoryId === "7") {
            setShowAdditionalContent(true);
        }
    };

    // cus

    useEffect(() => {
        const token = localStorage.getItem("aqua");
        if (!token) {
            console.error("No token found");
            return;
        }

        const jwt = jwtDecode(token);
        // console.log(jwt);

        fetch(`${baseUrl}/userInfo/getUserDetails`, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Failed to fetch user details");
                }
            })
            .then((data) => {
                if (data && data.result) {
                    setUserInfo1(data.result);
                    setFormData({
                        title: data.result.Title || "",
                        firstName: data.result.FirstName || "",
                        lastName: data.result.LastName || "",
                        phoneNumber: data.result.PhoneNumber || "",
                        email: data.result.Email || "",
                        address1: data.result.ClinicAddress || "",
                        clinicName: data.result.ClinicName || "",
                    });
                    setFormData1({
                        phoneNumber1: data.result.PhoneNumber || "",
                        email1: data.result.Email || "",
                        address11: data.result.ClinicAddress || "",
                        clinicName1: data.result.ClinicName || "",
                    });
                } else {
                    console.error("API returned undefined result:", data);
                }
            })
            .catch((error) => {
                console.error("Error fetching user details:", error);
            });

        const fakeDatafetch = () => {
            setTimeout(() => {
                setIsLoading(false);
            }, 1000);
        };
        fakeDatafetch();
    }, [baseUrl]);

    const handleViewFormClick = () => {
        setBook(!book);
    };
    const handleViewFormClick2 = () => {
        setBook2(!book2);
    };

    const closePopup = () => {
        setPopup({ ...popup, visible: false });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handlePhoneNumberChange = (phone) => {
        setFormData({ ...formData, phoneNumber: phone });
    };

    const handlePhoneNumberChange1 = (phone) => {
        setFormData({ ...formData, patientnumber: phone });
    };

    const handleBookingDateChange = (date) => {
        setFormData({ ...formData, bookingDate: date });
    };

    const handleDobChange = (date) => {
        setFormData({ ...formData, dob: date });
    };

    const handleChange12 = (e) => {
        const { name, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : prevData[name],
        }));
    };

    const handleDateChange = (date) => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = date.getHours() % 12 || 12;
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const amPm = date.getHours() >= 12 ? "PM" : "AM";

        const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${amPm}`;

        setFormData((prevState) => ({
            ...prevState,
            bookingDate: formattedDateTime,
        }));
    };

    const handleDateChange1 = (date) => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const formattedDate = `${day}-${month}-${year}`;

        setFormData((prevState) => ({
            ...prevState,
            dob: formattedDate,
        }));
    };

    const handleBooking = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(
                `${baseUrl}/booking/addcustomized`,
                formData
            );

            if (response.data.success) {
                setBook(false);

                setPopup({
                    visible: true,
                    message: "Request successfully submitted!",
                    isError: false,
                });

                setFormData({
                    title: "",
                    firstName: "",
                    lastName: "",
                    phoneNumber: "",
                    email: "",
                    gender: "",
                    address1: "",
                    address2: "",
                    clinicName: "",
                    postalCode: "",
                    country: "",
                    nhsNumber: "",
                    requiredTests: "",
                    serumTypes: "",
                    fastingOrPregnant: "",
                    clinicComplain: "",
                    additionalRemark: "",
                    city: "",
                    streetname: "",
                    // bookingDate: null,
                    dob: null,
                });
            } else {
                setPopup({
                    visible: true,
                    message: "Failed to submit booking. Please try again.",
                    isError: true,
                });
            }
        } catch (error) {
            console.error(error);
            setPopup({
                visible: true,
                message: "Failed to submit booking. Please try again.",
                isError: true,
            });
        }
    };

    //

    const handleGoBack = () => {
        window.history.back();
    };

    useEffect(() => {
        const token = localStorage.getItem("aqua");
        // console.log(token);
        if (token != null) {
            const userInfo = jwtDecode(token);
            setLoggedIn(true);
        }
    }, []);
    return (
        <>
            <div>
                {userInfo1.IsClinicOwner === "yes" &&
                    loggedIn && (
                        <button
                            onClick={handleViewFormClick2}
                            className="flex  gap-2 items-center text-[10px] xl:text-[18px] justify-between xl:pr-2 xl:pl-4 xl:pl-2 lg:px-1 lg:w-auto xl:h-[40px] h-[30px] w-auto bg-[#ffffff] text-[#234971] hover:bg-[#234971] hover:text-[#ffffff] border-2 hover:border-[#ffffff] transition-all duration-300 rounded-[40px] font-[600]"
                        >
                            Supply Request
                            <img
                                src="../assets/hero/more.png"
                                alt=""
                                className="bg-[#234971] xl:h-[30px] h-[27px] rounded-full lg:p-2 p-1"
                            />
                        </button>
                    )}
            </div>
            {book2 && (
                <div className="fixed top-0 left-0 bottom-0 right-0 p-4 z-50  left-0 w-full h-screen bg-black bg-opacity-[40%] grid place-content-center figtree px-3 md:px-0">

                    <div className=" lg:mx-[80px]  text-[#ffffff] border-[1px] border-white relative bg-[#11485B] h-auto lg:min-w-[800px] md:w-[600px] w-full md:rounded-[30px] rounded-[20px] py-6 shadow-lg">
                        <h2 className="text-center text-2xl font-bold mb-5">
                            Booking Form
                        </h2>
                        <form onSubmit={handleBooking1}>
                            <div className="lg:px-10 px-5 ">
                                <div
                                    className="absolute md:right-6 md:top-5 top-8 right-4 cursor-pointer"
                                    onClick={closePopup12}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="2"
                                        stroke="currentColor"
                                        className="w-4 h-4"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </div>

                                {/* Clinic and Phone Number */}
                                <div className="md:flex gap-3 md:mt-7 mt-5 ">
                                    <div className="inputbox flex-1">
                                        <input
                                            type="text"
                                            name="clinicName1"
                                            value={formData1.clinicName1}
                                            onChange={handleChange1}
                                            required
                                            className="w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                        />
                                        <span className="text-sm text-gray-300">
                                            Business Name*
                                        </span>
                                    </div>
                                    <div className="inputbox custom-phone-input flex-1">
                                        <PhoneInput
                                            defaultCountry="GB"
                                            value={formData1.phoneNumber1}
                                            onChange={handlePhoneNumberChange12}
                                            name="phoneNumber1"
                                            placeholder="Phone Number*"
                                            international
                                            withCountryCallingCode
                                            className="w-full p-2 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                        />
                                    </div>
                                </div>

                                {/* Email and Address */}
                                <div className="md:flex gap-3 md:mt-2">
                                    <div className="inputbox mt-7 md:mt-4 flex-1">
                                        <input
                                            type="email"
                                            name="email1"
                                            value={formData1.email1}
                                            onChange={handleChange1}
                                            required
                                            className="w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                        />
                                        <span className="text-sm text-gray-300">
                                            Email*
                                        </span>
                                    </div>
                                    <div className="inputbox mt-7 md:mt-4 flex-1">
                                        <input
                                            type="text"
                                            name="address11"
                                            value={formData1.address11}
                                            onChange={handleChange1}
                                            required
                                            className="w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                        />
                                        <span className="text-sm text-gray-300">
                                            Business Address*
                                        </span>
                                    </div>
                                </div>
                            </div>



                            <div className="lg:px-5 px-5">
                                {(formData1.materials || []).map(
                                    (material, index) => (
                                        <div className="bg-[#0F4651] shadow-lg shadow-cyan-500/50 lg:px-5 px-5 mt-5 pb-5 rounded-[10px] ">
                                            <div className="flex justify-end w-full">
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        removeMaterialRow(index)
                                                    }
                                                    className="md:ml-2 mt-6"
                                                >
                                                    <MdDeleteOutline className="text-[30px]" />
                                                </button>
                                            </div>
                                            <div
                                                key={index}
                                                className="md:flex gap-3 md:mt-2"
                                            >
                                                <div className="inputbox mt-4 flex-1">
                                                    <input
                                                        type="text"
                                                        name="materialName"
                                                        value={material.materialName}
                                                        onChange={(e) =>
                                                            handleMaterialChange(
                                                                index,
                                                                e
                                                            )
                                                        }
                                                        required
                                                        className="w-full p-2  rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                    />
                                                    <span className="text-sm text-gray-300">
                                                        Material Name
                                                    </span>
                                                </div>
                                                <div className="inputbox mt-4 flex-1">
                                                    <input
                                                        type="text"
                                                        name="qty"
                                                        value={material.qty}
                                                        onChange={(e) =>
                                                            handleMaterialChange(
                                                                index,
                                                                e
                                                            )
                                                        }
                                                        required
                                                        className="w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                    />
                                                    <span className="text-sm text-gray-300">
                                                        Qty
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="md:flex gap-3 md:mt-2">
                                                <div className="inputbox mt-4 flex-1">
                                                    <input
                                                        type="text"
                                                        name="unit"
                                                        value={material.unit}
                                                        onChange={(e) =>
                                                            handleMaterialChange(
                                                                index,
                                                                e
                                                            )
                                                        }
                                                        required
                                                        className="w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                    />
                                                    <span className="text-sm text-gray-300">
                                                        Unit
                                                    </span>
                                                </div>
                                                <div className="inputbox mt-4 flex-1">
                                                    <input
                                                        type="text"
                                                        name="manufacturerName"
                                                        value={
                                                            material.manufacturerName
                                                        }
                                                        onChange={(e) =>
                                                            handleMaterialChange(
                                                                index,
                                                                e
                                                            )
                                                        }
                                                        required
                                                        className="w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                    />
                                                    <span className="text-sm text-gray-300">
                                                        Current Stock
                                                    </span>
                                                </div>
                                                <div className="md:flex gap-3 md:mt-2">
                                                    <div className="inputbox mt-4 flex-1">
                                                        <input
                                                            type="text"
                                                            name="batchNumber"
                                                            value={material.batchNumber}
                                                            onChange={(e) =>
                                                                handleMaterialChange(
                                                                    index,
                                                                    e
                                                                )
                                                            }
                                                            required
                                                            className="w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                        />
                                                        <span className="text-sm text-gray-300">
                                                            Expected Delivery{" "}
                                                        </span>
                                                    </div>
                                                    <div className="inputbox mt-4 flex-1">
                                                        <input
                                                            type="text"
                                                            name="expiryDate"
                                                            value={material.expiryDate}
                                                            onChange={(e) =>
                                                                handleMaterialChange(
                                                                    index,
                                                                    e
                                                                )
                                                            }
                                                            required
                                                            className="appearance-none focus:text-black w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                            onFocus={(e) =>
                                                                (e.target.type = "date")
                                                            }
                                                            onBlur={(e) => {
                                                                if (!e.target.value)
                                                                    e.target.type = "text";
                                                            }}
                                                            placeholder=""
                                                        />
                                                        <span className="text-sm text-gray-300">
                                                            Expiry Date
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="md:flex gap-3 md:mt-2"></div>
                                            </div>
                                            <div key={index} className="md:flex gap-3 md:mt-2">
                                                <div className="inputbox mt-4 flex-1">
                                                    <input
                                                        type="text"
                                                        name="materialName"
                                                        value={material.materialName}
                                                        onChange={(e) => handleMaterialChange(index, e)}
                                                        required
                                                        className="w-full p-2  rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                    />
                                                    <span className="text-sm text-gray-300">Material Name</span>
                                                </div>
                                                <div className="inputbox mt-4 flex-1">
                                                    <input
                                                        type="text"
                                                        name="qty"
                                                        value={material.qty}
                                                        onChange={(e) => handleMaterialChange(index, e)}
                                                        required
                                                        className="w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                    />
                                                    <span className="text-sm text-gray-300">Qty</span>
                                                </div>
                                            </div>
                                            <div className="md:flex gap-3 md:mt-2">
                                                <div className="inputbox mt-4 flex-1">
                                                    <input
                                                        type="text"
                                                        name="unit"
                                                        value={material.unit}
                                                        onChange={(e) => handleMaterialChange(index, e)}
                                                        required
                                                        className="w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                    />
                                                    <span className="text-sm text-gray-300">Unit(Eg:Box,Pack,Pieces)</span>
                                                </div>
                                                <div className="inputbox mt-4 flex-1">
                                                    <input
                                                        type="text"
                                                        name="manufacturerName"
                                                        value={material.manufacturerName}
                                                        onChange={(e) => handleMaterialChange(index, e)}
                                                        required
                                                        className="w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                    />
                                                    <span className="text-sm text-gray-300">Current Stock</span>
                                                </div>
                                            </div>
                                            <div className="md:flex gap-3 md:mt-2">
                                                <div className="inputbox mt-4 flex-1">
                                                    <input
                                                        type="text"
                                                        name="batchNumber"
                                                        value={material.batchNumber}
                                                        onChange={(e) => handleMaterialChange(index, e)}
                                                        required
                                                        className="appearance-none focus:text-black w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                        onFocus={(e) => (e.target.type = "date")}
                                                        onBlur={(e) => {
                                                            if (!e.target.value) e.target.type = "text";
                                                        }}
                                                        placeholder=""
                                                    />
                                                    <span className="text-sm text-gray-300">Expected Delivery Date </span>
                                                </div>
                                                <div className="inputbox mt-4 flex-1">
                                                    <input
                                                        type="text"
                                                        name="expiryDate"
                                                        value={material.expiryDate}
                                                        onChange={(e) => handleMaterialChange(index, e)}
                                                        required
                                                        className="appearance-none focus:text-black w-full p-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-blue-300"
                                                        onFocus={(e) => (e.target.type = "date")}
                                                        onBlur={(e) => {
                                                            if (!e.target.value) e.target.type = "text";
                                                        }}
                                                        placeholder=""
                                                    />
                                                    <span className="text-sm text-gray-300">Current Expiry Date</span>
                                                </div>
                                            </div>
                                            <div className="md:flex gap-3 md:mt-2">

                                            </div>
                                        </div>
                                    ))}

                            </div>

                            <div className="flex justify-center mt-6">
                                <button
                                    type="button"
                                    onClick={addMaterialRow}
                                    className="text-[#11485B] bg-[#ffffff] text-[14px] lg:text-[18px] w-[280px] p-2 md:h-[40px] rounded-[5px] hover:bg-[#0ca0b0] font-[600]"
                                >
                                    {formData1?.materials?.length > 0
                                        ? "Add More Supply "
                                        : "Add Supply Request"}
                                </button>
                            </div>

                            {formData1?.materials?.length > 0 && (
                                <div className="flex justify-center mt-6">
                                    <button
                                        type="submit"
                                        className="text-[#11485B] text-[14px] lg:text-[18px] bg-[#ffffff] w-[280px] p-2 md:h-[40px] rounded-[5px] hover:bg-[#0ca0b0] font-[600]"
                                    >
                                        Submit
                                    </button>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </>
    )
}

export default SupplyRequest